import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadTheme } from "../themes/theme";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

export const useRouteTheme = () => {
  const location = useLocation();
  const selectedTheme =
    useSelector((state: RootState) => state.giftTable.theme) || "base";

  useEffect(() => {
    loadTheme("base");
  }, [location, selectedTheme]);
};
